// extracted by mini-css-extract-plugin
module.exports = {"SocialContainer":"socialsPersonal_SocialContainer__3u2GS","SocialLink":"socialsPersonal_SocialLink__2hbeX"};